import { withDependencies } from '@wix/thunderbolt-ioc'
import { Props, IPropsStore } from '@wix/thunderbolt-symbols'
import { ComponentWillMount, ViewerComponent } from 'feature-components'
import { IPreviewTooltipCallback, PreviewTooltipCallbackSymbol } from 'feature-click-handler-registrar'
import { PreviewTooltipProps } from '@wix/thunderbolt-becky-types'

const COMPONENT_TYPES_WITH_TOOLTIP = [
	'FacebookShare',
	'WFacebookLike',
	'WFacebookComment',
	'LoginSocialBar',
	'TinyMenu',
	'QuickActionBar',
	'ItunesButton',
	'PayPalButton',
	'PinterestPinIt',
	'VKShareButton',
	'WGooglePlusOne',
	'WTwitterFollow',
	'WTwitterTweet',
	'YouTubeSubscribeButton',
	'DropDownMenu',
	'LanguageSelector',
	'SocialAuth',
	'LoginButton',
	'ComboBoxInput',
]

export const TOOLTIP_PROP_NAME = 'showTooltip' as const

const componentsPreviewTooltipFactory = (
	{ getPreviewTooltipCallback }: IPreviewTooltipCallback,
	propsStore: IPropsStore
): ComponentWillMount<ViewerComponent> => {
	return {
		componentTypes: COMPONENT_TYPES_WITH_TOOLTIP,
		componentWillMount(compWithTooltip) {
			const tooltipProps: PreviewTooltipProps = {
				showTooltip: (rect, text, props?) => getPreviewTooltipCallback()(rect, text, props),
			}
			propsStore.update({
				[compWithTooltip.id]: tooltipProps,
			})
		},
	}
}

export const ComponentsPreviewTooltip = withDependencies(
	[PreviewTooltipCallbackSymbol, Props],
	componentsPreviewTooltipFactory
)
